const minMax = (a, b, c) => Math.min(Math.max(a, b), c);

export default minMax;
